import React from 'react';

/**
 * Theme-cycle icons.
 *
 * Same spec as the radar set: 16-unit box, 1.5 stroke, round caps,
 * `currentColor`. Drawn rather than borrowed from the unicode table, so they
 * keep one weight next to the nav's monospace type instead of inheriting
 * whatever the platform emoji font decides.
 */

type P = { size?: number };

const Svg: React.FC<P & { children: React.ReactNode }> = ({ size = 14, children }) => (
    <svg
        width={size} height={size} viewBox="0 0 16 16"
        fill="none" stroke="currentColor" strokeWidth={1.5}
        strokeLinecap="round" strokeLinejoin="round"
        aria-hidden="true" focusable="false"
        style={{ display: 'block' }}
    >
        {children}
    </svg>
);

export const Sun: React.FC<P> = p => (
    <Svg {...p}>
        <circle cx="8" cy="8" r="3.1" />
        <path d="M8 1.4v1.6M8 13v1.6M14.6 8H13M3 8H1.4M12.67 3.33l-1.13 1.13M4.46 11.54l-1.13 1.13M12.67 12.67l-1.13-1.13M4.46 4.46L3.33 3.33" />
    </Svg>
);

export const Moon: React.FC<P> = p => (
    <Svg {...p}>
        <path d="M13.2 9.6A5.6 5.6 0 0 1 6.4 2.8a5.6 5.6 0 1 0 6.8 6.8z" />
    </Svg>
);

/** System default — a display, because the choice belongs to the device. */
export const SystemTheme: React.FC<P> = p => (
    <Svg {...p}>
        <rect x="1.9" y="3" width="12.2" height="8" />
        <path d="M5.5 13.6h5" />
    </Svg>
);
